import {
  initRawSchema,
  toListContent,
  toParagraphContent,
} from '@principle-theorem/editor';
import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/sterilisation'],
  validationMode: 'any',
};

export const sterilisationTrackingStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.SterilisationTracking,
  category: PracticeSetupStepCategory.Miscellaneous,
  title: 'Set Up Sterilisation Tracking',
  description: initRawSchema([
    toParagraphContent(
      `Principle's sterilisation tracking system allows your practice to monitor and record the sterilisation of equipment. Before your team can begin logging sterilisation activity, your equipment needs to be configured on this page. Create entries for:`
    ),
    toListContent([
      `Sterilisation Machines used at the practice`,
      `Sterilisation Cycle Types`,
      `Sterilisation Equipment & Instruments`,
      `Sterilisation Packs (collections of individual equipment items commonly packed together)`,
    ]),
  ]),
  dependsOn: [],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/sterilisation`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason:
            'Please review the sterilisation settings before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
